import { getAmplifyErrorMessage } from './util/amplifyError';
import {
  FetchMFAPreferenceOutput,
  fetchMFAPreference as amplifyFetchMFAPreference,
} from 'aws-amplify/auth';

export const fetchMFAPreference =
  async (): Promise<FetchMFAPreferenceOutput> => {
    try {
      const res = await amplifyFetchMFAPreference();
      return { ...res };
    } catch (error) {
      const errorMessage = getAmplifyErrorMessage(error);
      throw new Error(errorMessage);
    }
  };
